export const GET_FILTERS_DATA_SUCCESS = 'GET_FILTERS_DATA_SUCCESS';
export const GET_FILTERS_DATA_FAILED = 'GET_FILTERS_DATA_FAILED';
// export const GET_OVERVIEW_SUCCESS = 'GET_OVERVIEW_SUCCESS'; // useless now
export const GET_FINANCIALS_TOTALS_SUCCESS = 'GET_FINANCIALS_TOTALS_SUCCESS';
export const GET_FINANCIALS_LIST_SUCCESS = 'GET_FINANCIALS_LIST_SUCCESS';
